/**
 * 직분 컬러 마커 (디자인 가이드: 뱃지 대신 사각 마커)
 * 공고 구분/희망 사역 텍스트를 보고 직분 계열 modifier 를 돌려준다.
 * 사용: <span className={roleMarkerClass(item.sort)}>{item.sort}</span>
 */
export type RoleKind = 'senior' | 'assoc' | 'edu' | 'worship' | 'admin' | 'mission';

const RULES: Array<[RoleKind, RegExp]> = [
  ['mission', /선교|해외/],
  ['worship', /찬양|음악|반주|지휘|성가|방송|미디어/],
  ['admin', /사무|관리|행정|직원|간사|시설|기관|단체|학교/],
  ['senior', /담임/],
  ['edu', /교육|전도사|파트|유치|유초|아동|중고|청소년|주일학교/],
  ['assoc', /부목사|전임|준전임|목사|교구|청년/],
];

export function roleKind(text?: string | null): RoleKind {
  const t = text || '';
  for (const [kind, re] of RULES) {
    if (re.test(t)) return kind;
  }
  return 'assoc';
}

export function roleMarkerClass(text?: string | null): string {
  return `mm-role mm-role--${roleKind(text)}`;
}
